import styled from "styled-components/macro";
import Paper from "@mui/material/Paper";
import {
  medBlue,
  blueButton,
  lighterGrey,
  darkBlue,
  lightBlueButton,
  transparentBlue,
  darkModeBackgroundColor,
  darkModeTextColor,
  muiButtonText,
  darkModeTitleBackgroundColor,
} from "../../constants/colors";
import {
  BREAKPOINT_MOBILE,
  NAV_HEIGHT_PX,
  EXPAND_ICON_TRANSITION,
} from "../../constants/constants";

export const SectionStyles = styled(Paper)`
  width: 100%;
  * {
    box-sizing: border-box;
  }
  margin-bottom: 1em;
`;
export const SettingsStyles = styled.div<{ $isDarkMode: boolean }>`
  position: relative;
  /* grey background */
  &:before {
    content: "";
    position: fixed;
    top: 0;
    right: -16px; /* scrollbar width */
    bottom: 0;
    left: 0;
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeBackgroundColor : lighterGrey};
  }

  .expandedTilesConfig {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    .MuiListItem-button {
      height: 40px;
      display: flex;
      justify-content: center;
    }
    .expandMoreIcon {
      transition: ${EXPAND_ICON_TRANSITION};
    }
  }
  .smallInput {
    padding-right: 1.5rem;
    margin-top: -1rem;
    display: flex;
    label {
      font-size: 0.8rem;
      flex-grow: 1;
      text-align: right;
      padding-right: 1rem;
    }
    input {
      width: 2.8rem;
      position: relative;
      text-align: right;
    }
  }
  input {
    text-align: right;
  }
  .smallSwitch {
    .MuiSwitch-root {
      transform: scale(0.8);
    }
    &.disabled {
      .MuiIconButton-label {
        opacity: 0.5;
      }
    }
    label {
      margin-top: -8px;
      padding-top: 0;
      .MuiFormControlLabel-label {
        text-align: right;
        padding-right: 8px;
        font-size: 0.8rem;
      }
      .MuiCheckbox-root:hover {
        background-color: ${transparentBlue};
      }
    }
  }
  hr {
    background-color: rgba(0, 0, 0, 0.12);
    display: block;
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      display: none;
    }
  }
  min-height: calc(100vh - ${NAV_HEIGHT_PX}px);
  hr {
    display: block;
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      &:not(.alwaysVisible) {
        display: none;
      }
    }
  }
  .settingsWrapper {
    &.helpAndFeedbackWrapper {
      margin-top: 64px;
      ul {
        padding: 0;
      }
      li,
      .btnFeedback {
        padding: 14px 16px;
        svg {
          fill: rgba(0, 0, 0, 0.54);
        }
        div {
          min-width: unset;
          padding-right: 12px;
        }
      }
    }
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeTitleBackgroundColor : "white"};
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      background: none;
    }
    padding: 0;
    max-width: 680px;
    display: flex;
    flex-direction: column;
    margin: auto;
    min-height: 100%;
    position: relative;
    .title {
      padding: 3rem 1rem 1rem 1rem;
      font-size: 1rem;
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : medBlue};
      background: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTitleBackgroundColor : "white"};
    }
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      padding: 0 4px;
      .title {
        padding: 1rem 0;
        background: none;
        color: ${({ $isDarkMode }) =>
          $isDarkMode ? darkModeTextColor : "unset"};
      }
    }
    .list {
      display: flex;
      flex-direction: column;
    }
    .metricsTitle {
      padding: 0;
      span {
        transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
        font-size: 1.15rem;
        color: ${medBlue};
      }
    }
    .metricsList {
      .metricsToDisplayTitle {
        text-align: left;
        flex-grow: 1;
      }
      .metricsListTitle {
        padding: 0 0 8px 0;
        width: 100%;
        position: relative;
        text-align: center;
        .header {
          width: 150px;
        }
      }
      .metricCheckboxesRow {
        padding: 0 16px 0 32px;
        display: flex;
        align-items: center;
        .metricName {
          flex-grow: 1;
        }
        .metricCheckboxes {
          .MuiCheckbox-root {
            width: 150px;
          }
        }
      }
    }
    .toggleSwitch div div {
      padding-left: 13px;
    }

    svg.MuiSvgIcon-root path {
      color: ${blueButton};
    }
    .firstColumn {
      margin-left: 2px;
    }
  }
  .flex {
    display: flex;
  }
  .listItemCheckbox {
    label {
      margin: 0 0 0 16px;
      width: 100%;
      & > span:last-child {
        width: 100%;
      }
    }
  }
  .metricDropdown {
    label {
      color: ${({ $isDarkMode }) =>
        $isDarkMode ? darkModeTextColor : muiButtonText};
    }
    display: flex;
    justify-content: space-between;
    .dropdown {
    }
  }
  .MuiTextField-root .MuiInput-root {
    width: 220px;
  }
`;

export const ToggleStyles = styled.div<{ $isDarkMode: boolean }>`
  display: flex;
  align-items: center;
  .MuiSvgIcon-root {
    transform: scale(0.9);
    transform-origin: left;
  }
  label {
    margin: 0;
    padding: 8px 16px;
    width: 100%;
    & > span:last-child {
      width: 100%;
    }
  }
  &.checked {
    label > span > span:last-of-type {
      /* MuiSwitch-bar*/
      background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? lightBlueButton : medBlue} !important;
    }
    span.MuiSwitch-thumb {
      color: ${({ $isDarkMode }) => ($isDarkMode ? medBlue : darkBlue)};
    }
  }
`;

export const LabelWithSubtitleStyles = styled.div`
  div {
    padding-left: 0 !important;
  }
  .subtitle {
    font-size: 0.75rem;
  }
`;
